<template>
  <div v-if="visible" class="security-upgrade-modal-overlay">
    <div class="security-upgrade-modal">
      <div class="modal-header">
        <h3 class="title">{{ modalTitle }}</h3>
      </div>
      
      <div class="modal-body">
        <p class="description">{{ modalContent }}</p>
      </div>
      
      <div class="actions">
        <button class="btn-cancel" @click="handleClose">
          {{ $t('security.upgrade_modal.close') }}
        </button>
        <button 
          v-if="showVerifyButton" 
          class="btn-confirm" 
          @click="handleVerify"
        >
          {{ $t('security.upgrade_modal.verify_now') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SecurityLevelUpgradeModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    currentLevel: {
      type: Number,
      required: true
    },
    targetLevel: {
      type: Number,
      required: true
    }
  },
  computed: {
    modalTitle() {
      if (this.currentLevel === 1 && this.targetLevel === 3) {
        return this.$t('security.upgrade_modal.title_required_step');
      }
      if (this.targetLevel === 4) {
        return this.$t('security.upgrade_modal.title_level_4');
      }
      if (this.targetLevel === 2) {
        return this.$t('security.upgrade_modal.title_level_2');
      }
      if (this.targetLevel === 3) {
        return this.$t('security.upgrade_modal.title_level_3');
      }
      return '';
    },
    modalContent() {
      if (this.currentLevel === 1 && this.targetLevel === 3) {
        return this.$t('security.upgrade_modal.content_required_step');
      }
      if (this.targetLevel === 4) {
        return this.$t('security.upgrade_modal.content_level_4');
      }
      if (this.targetLevel === 2) {
        return this.$t('security.upgrade_modal.content_level_2');
      }
      if (this.targetLevel === 3) {
        return this.$t('security.upgrade_modal.content_level_3');
      }
      return '';
    },
    showVerifyButton() {
      return this.targetLevel !== 4;
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleVerify() {
      this.$emit('verify', this.targetLevel);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";

.security-upgrade-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.security-upgrade-modal {
  background: var(--background-color-modal);
  padding: 30px;
  border-radius: 8px;
  width: 450px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  
  .modal-header {
    margin-bottom: 25px;
    border-bottom: none !important;
    
    .title {
      text-align: center;
      margin: 0;
      font-family: $font-inter-bold;
      color: var(--text-primary-color);
      font-size: 24px;
      line-height: normal;
    }
  }

  .modal-body {
    margin-bottom: 30px;
    
    .description {
      display: block;
      text-align: center;
      margin: 0;
      font-family: $font-inter-regular;
      color: var(--text-second-color);
      font-size: 14px;
      line-height: 1.6;
    }
  }

  .actions {
    display: flex;
    justify-content: center;
    gap: 15px;
    
    button {
      flex: 1;
      padding: 12px 0;
      font-size: 16px;
      border-radius: 8px;
      font-family: $font-inter-medium;
      cursor: pointer;
      transition: all 0.2s;
      border: none;
      outline: none;
      
      &.btn-confirm {
        background-color: $color-caribbean-green;
        color: $color-grey-dark;
        
        &:hover {
          background-color: $color-aquamarine;
        }
      }

      &.btn-cancel {
        background: var(--background-color-second);
        color: var(--text-primary-color);
        
        &:hover {
          background: var(--bgr-hover-row);
        }
      }
    }
  }
}

@media (max-width: 576px) {
  .security-upgrade-modal {
    width: 90%;
    padding: 20px;
    
    .actions {
      flex-direction: column;
      
      button {
        width: 100%;
      }
    }
  }
}
</style>
